import { render, staticRenderFns } from "./VisionLayout.vue?vue&type=template&id=bfa0ea44&scoped=true&"
import script from "./VisionLayout.vue?vue&type=script&lang=js&"
export * from "./VisionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa0ea44",
  null
  
)

export default component.exports